import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

import { SiteContextConfig, WindowRef } from '@spartacus/core';

import { LANGUAGES } from '@app/core/constants/languages.constant';
import { CONTEXT_CONFIG } from '@app/spartacus/constants';

export const languageContextConfigFactory = (winRef: WindowRef): SiteContextConfig => {
  let languagesList = [...LANGUAGES];

  if (isPlatformBrowser(inject(PLATFORM_ID))) {
    const navigatorLang = winRef?.nativeWindow?.navigator?.language?.substring(0, 2) ?? 'en';
    if (languagesList.includes(navigatorLang)) {
      languagesList = languagesList.filter((item) => item !== navigatorLang);
      languagesList.unshift(navigatorLang);
    }
  }
  return { context: { ...CONTEXT_CONFIG, language: languagesList } };
};
